export const DEVELOPMENT_APP_MODE = "development";
